import { render, staticRenderFns } from "./chefiaPendentes.vue?vue&type=template&id=7390bd38&scoped=true&"
import script from "./chefiaPendentes.vue?vue&type=script&lang=js&"
export * from "./chefiaPendentes.vue?vue&type=script&lang=js&"
import style0 from "./chefiaPendentes.vue?vue&type=style&index=0&id=7390bd38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390bd38",
  null
  
)

export default component.exports